// extracted by mini-css-extract-plugin
module.exports = {"container":"Cart_container__2IClo","cart":"Cart_cart__1cQaE","head":"Cart_head__WlkNB"};